import React from 'react';
import Projects from './Projects';
import WorkHeader from './WorkHeader';

const Work = () => {
   return (
      <div className='container section-margin-top'>
         <WorkHeader />
         <Projects />
      </div>
   );
};

export default Work;
